export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const validateURL = (url) => {
  if (!url || url.length === 0) {
    return true;
  }
  try {
    const newUrl = new URL(url);
    return newUrl.protocol === 'http:' || newUrl.protocol === 'https:';
  } catch (err) {
    return false;
  }
};

export const validateYoutubeURL = (url) => {
  if (!url || url.length === 0) {
    return true;
  }
  try {
    const newUrl = new URL(url);
    return newUrl.hostname === 'youtu.be';
  } catch (err) {
    return false;
  }
};

export const cleanHtml = (html) => {
  if (!html || html.length === 0) {
    return '';
  }
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'strong', 'em', 'b', 'i', 'a'].forEach((tag) => {
    doc.querySelectorAll(tag).forEach((el) => {
      const text = document.createTextNode(el.textContent);
      el.replaceWith(text);
    });
  });

  return doc.body.innerHTML;
};
